import * as React from 'react';
import { useState, useEffect } from 'react';

export interface IconProps {
  url: string;
  className?: string;
}

export const Icon = (props: IconProps) => {
  const [src, setSrc] = useState('');
  
  useEffect(() => {
    setSrc(props.url);
  }, []);
  
  return <img className={props.className} src={src} />;
};

export const IconDisplay = ({visible, url, classNames}) => url && visible ? <Icon className={classNames} url={url} /> : null;
